import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProgrammerContext } from '@/hid/ProgrammerContext';

const TargetInfo8051: React.FC = () => {
  const { t } = useTranslation('webflash');
  const { selectedChip, targetInfo } = useProgrammerContext();

  if (!selectedChip) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          {t('chip.targetInfo')}
        </h3>
        <p className="text-sm text-gray-400">{t('chip.noChipSelected')}</p>
      </div>
    );
  }

  const formatSize = (bytes: number): string => {
    if (bytes >= 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${bytes} B`;
  };

  const rows = [
    { label: t('chip.chipName'), value: selectedChip.name },
    { label: t('chip.family'), value: selectedChip.family },
    {
      label: t('chip.deviceId'),
      value: targetInfo
        ? `0x${targetInfo.deviceId.toString(16).toUpperCase().padStart(8, '0')}`
        : `0x${selectedChip.deviceId.toString(16).toUpperCase().padStart(8, '0')} (expected)`,
    },
    { label: t('chip.apromSize'), value: formatSize(selectedChip.flashSize) },
    ...(selectedChip.ldromMaxSize
      ? [{ label: t('chip.ldromSize'), value: formatSize(selectedChip.ldromMaxSize) }]
      : []),
    { label: t('chip.pageSize'), value: formatSize(selectedChip.pageSize) },
    ...(selectedChip.configSize > 0
      ? [{ label: t('chip.configBytes'), value: `${selectedChip.configSize} bytes` }]
      : []),
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('chip.targetInfo')}
      </h3>
      <div className="grid grid-cols-2 gap-2 text-sm">
        {rows.map((row) => (
          <React.Fragment key={row.label}>
            <span className="text-gray-500 dark:text-gray-400">{row.label}</span>
            <span className="font-mono text-gray-900 dark:text-white">{row.value}</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default TargetInfo8051;
